import React from 'react';
// import ConstantsService from '../../services/constants.service';
import { useFormik } from 'formik';
// import { IoIosAddCircle } from "react-icons/io";
// import { IoCloseCircleOutline } from "react-icons/io5";
import AppButton from 'components/FormsUI/AppButton/appButton';


const validate = values => {
    const errors = {};
    if (!values.ConstantName) {
        errors.ConstantName = 'Required';
        // errors.general = "Please fill all fields";
    }
    if (!values.ConstantValue) {
        errors.ConstantValue = 'Required';
        // errors.general = "Please fill all fields";
    }
    if (!values.ConstantDescription) {
        errors.ConstantDescription = 'Required';
        //errors.general = "Please fill all fields";
    }
    return errors;
}
export default function WriteConstantRow({ constant, onSubmitted }) {

    const closeLine = () => { onSubmitted(null, "closeLine"); }

    const formik = useFormik({
        initialValues: {
            ConstantName: constant?.constantName,
            ConstantValue: constant?.constantValue,
            ConstantDescription: constant?.constantDescription
        },
        validate,
        onSubmit: async (values) => {
            if (formik.isValid) {
                if (constant) {
                    values.id = constant.id;
                    onSubmitted(values, "update");
                } else {
                    values.id = "0";
                    onSubmitted(values, "insert");
                }
            }
        }
    });
    return (
        <form onSubmit={formik.handleSubmit}>
            <div key={constant?.id} className="row border-bottom">
                <input id="id" name="id" type="hidden" value={formik.values.id} />
                <div className="col">
                    <input name="ConstantName" id="ConstantName" type="text"
                        onChange={formik.handleChange} value={formik.values.ConstantName}
                        className="form-control" placeholder="ConstantName" />
                    {formik.errors.ConstantName ? <div className="alert alert-danger">{formik.errors.ConstantName}</div> : null}
                </div>
                <div className="col">
                    <input name="ConstantValue" id="ConstantValue" type="text"
                        onChange={formik.handleChange} value={formik.values.ConstantValue}
                        className="form-control" placeholder="ConstantValue" />
                    {formik.errors.ConstantValue ? <div className="alert alert-danger">{formik.errors.ConstantValue}</div> : null}
                </div>

                <div className="col">
                    <input name="ConstantDescription" id="ConstantDescription" type="text"
                        onChange={formik.handleChange} value={formik.values.ConstantDescription}
                        className="form-control" placeholder="ConstantDescription" />
                    {formik.errors.ConstantDescription ? <div className="alert alert-danger">{formik.errors.ConstantDescription}</div> : null}
                </div>
                <div className="col">
                    <AppButton type="submit" label={constant ? 'Submit' : 'Save'} classes="margingRight" ></AppButton>
                    <AppButton action={closeLine} label="X" color="danger"></AppButton>
                </div>

                <div className="row">
                    <div className="col">
                        {formik.errors.general ? <div className="alert alert-danger">{formik.errors.general}</div> : null}

                    </div>
                </div>
            </div>


        </form>
    )
}